import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EmojiTransportationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"emoji_transportation"}/>
}
